/* ============================================================
   fleetOverviewApi — PF-4 (TASK-74482edf): thin fetch for
   GET /api/v1/providers/fleet-overview.

   Standalone module on purpose: the shared api/client.ts is
   mid-change by the concurrent PF-3 run (uncommitted catalog
   picker work); this card keeps its footprint out of that file.
   Same conventions as client.ts: Bearer when a session exists,
   ApiResult envelope unwrapping, readable ru error messages.
   ============================================================ */

import { getAccessToken } from '../auth/tokenStore';
import type { ApiResult } from '../types';
import type { ProviderFleetOverview } from '../types/fleet';

const BASE_URL = `${import.meta.env.VITE_API_BASE ?? ''}/api/v1`;

export async function getProviderFleetOverview(): Promise<ProviderFleetOverview> {
  const headers: Record<string, string> = {};
  const token = getAccessToken();
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${BASE_URL}/providers/fleet-overview`, { headers });

  const text = await res.text();
  let body: unknown = null;
  if (text.length > 0) {
    try {
      body = JSON.parse(text);
    } catch {
      // Non-JSON body — handled below.
    }
  }

  if (body && typeof body === 'object' && 'isSuccess' in body) {
    const result = body as ApiResult<ProviderFleetOverview>;
    if (result.isSuccess && result.value) return result.value;
    throw new Error(result.error ?? 'Не удалось загрузить обзор парка');
  }

  throw new Error(`Сервер вернул ошибку (HTTP ${res.status})`);
}
